var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[(_vm.showBanner && _vm.bannerActive)?_c('banner',{on:{"close":function($event){_vm.showBanner = false}}},[_vm._v(" We’ll be closed for our annual winter break from January 1st to January 22nd and will be reopening on January 23rd. ")]):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }